import { useQuery } from "@tanstack/react-query";
import { getAllCategories } from "@/api/category";

export const useCategories = (options = {}) => {
  return useQuery({
    queryKey: ["categories"],
    queryFn: () => getAllCategories(),
    ...options,
  });
};
